export default __webpack_public_path__ + "static/homepage-supplier2-fb4228b327771fa31fd654ffc5daee1f.png";